import React, { useState, useEffect } from "react";
import stylesLayout from "./styles/auth-layout.module.css";
import stylesForms from "./styles/auth-forms.module.css";
import {
  PRIVACY_POLICY_LINK,
  TERMS_OF_SERVICE_LINK,
  COOKIE_POLICY_LINK,
  WISHLINK_LOGIN_PAGE_CREATORS_IMAGE,
  WISHLINK_LOGIN_PAGE_LOGO,
} from "../utils/constants";
import OnboardingModal from "./GetStarted";
import ScrollingLogos from "./ScrollingLogos";
import { triggerGa } from "../utils/gaUtils"; // Import the modal component
import { useNavigate } from "react-router-dom";

const stats = [
  { value: 15000, start: 10000, label: "Creators" },
  { value: 600000, start: 5000, label: "Content Pieces" },
  { value: 500000000, start: 250000000, label: "Total Clicks" },
  { value: 2000000000, start: 1000000000, label: "Impressions" },
  { value: 10000000000, start: 5000000000, label: "GMV Generated" },
];

const formatNumber = (num) => {
  if (num >= 10000000) {
    return (num / 10000000).toFixed(0) + "Cr+";
  } else if (num >= 100000) {
    return (num / 100000).toFixed(0) + "Lac+";
  } else if (num >= 1000) {
    return num.toFixed(0) + "+";
  }
  return num.toLocaleString() + "+";
};

export default function LoginPageLayout({ children, openSignupForm }) {
  const navigate = useNavigate();
  const [animatedStats, setAnimatedStats] = useState(
    stats.map((stat) => stat.start),
  );
  const [isModalOpen, setIsModalOpen] = useState(openSignupForm || false); // State for modal visibility

  useEffect(() => {
    const duration = 2000; // Total duration of animation in ms
    const steps = 60; // Number of animation steps
    const interval = duration / steps; // Interval between steps
    const stepValues = stats.map((stat) => (stat.value - stat.start) / steps);
    let currentStep = 0;

    const intervalId = setInterval(() => {
      currentStep++;
      setAnimatedStats((prevStats) =>
        prevStats.map((val, index) =>
          currentStep < steps ? val + stepValues[index] : stats[index].value,
        ),
      );
      if (currentStep >= steps) {
        clearInterval(intervalId);
      }
    }, interval);
    return () => clearInterval(intervalId);
  }, []);

  const handleOpenModal = () => {
    triggerGa({
      category: "Signup",
      action: "button_click",
      label: "get_started_with_wishlink",
      label2: "",
      page: "Login",
      screenName: "Login",
    });
    setIsModalOpen(true);
    navigate("/register");
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate("/login");
  };

  return (
    <div className={stylesLayout.authContainer}>
      <div className={stylesLayout.authSection}>
        <img
          src={WISHLINK_LOGIN_PAGE_LOGO}
          alt="Wishlink Logo"
          className={stylesLayout.logo}
        />
        {children}
        <div className={stylesForms.signupText}>
          Don't have an account?
          <span
            onClick={handleOpenModal}
            className={stylesForms.orangeLink}
            style={{ cursor: "pointer" }}
          >
            Get Started with Wishlink
          </span>
        </div>
        <footer className={stylesLayout.footer}>
          <a
            href={TERMS_OF_SERVICE_LINK}
            className={stylesLayout.footerLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          <a
            href={PRIVACY_POLICY_LINK}
            className={stylesLayout.footerLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href={COOKIE_POLICY_LINK}
            className={stylesLayout.footerLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>
        </footer>
      </div>
      <div className={stylesLayout.rightSection}>
        <div className={stylesLayout.creatorShowcase}>
          <h1 className={stylesLayout.heading}>
            Unlock Next Level Growth with Creators
          </h1>
          <img
            src={WISHLINK_LOGIN_PAGE_CREATORS_IMAGE}
            alt="Creator Showcase"
            className={stylesLayout.creatorCircle}
          />
        </div>
        <div className={stylesLayout.statsContainer}>
          {stats.map(({ label }, index) => (
            <div key={label} className={stylesLayout.statItem}>
              <div className={stylesLayout.statValue}>
                {formatNumber(Math.round(animatedStats[index]))}
              </div>
              <div className={stylesLayout.statLabel}>{label}</div>
            </div>
          ))}
        </div>
        <div className={stylesLayout.scrollingBrandContainer}>
          <div>
            <h1 className={stylesLayout.trustedByHeading}>Trusted By:</h1>
          </div>
          <div className={stylesLayout.scrollWrapper}>
            <ScrollingLogos />
          </div>
        </div>
      </div>
      <OnboardingModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
}
